import styled from 'styled-components'

export const SiderbarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100% - 50px);
  margin-top: 50px;

  .ant-menu-item a {
    color: #3a5a7d;
    font-weight: 600;
    font-size: 0.78rem;
  }

  .menu-item-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 0;
    width: auto !important;
    height: auto !important;
    border: 0 !important;
    border-radius: 0 !important;
    background: transparent !important;
    color: inherit;
    font-size: 16px;
    line-height: 1;
  }

  .menu-item-icon svg {
    display: block;
  }

  .ant-menu-item-icon,
  .ant-menu-submenu-title .ant-menu-item-icon {
    margin-inline-end: 12px;
  }

  .ant-menu-item-only-child {
    a {
      color: #000;
    }

    &:hover {
      a {
        color: #3a5a7d;
      }
    }
  }

  .ant-menu-sub .ant-menu-item {
    padding-left: 28px !important;
  }

  .ant-menu-submenu .ant-menu-submenu-title {
    padding-left: 18px !important;
  }

  .ant-menu-submenu .ant-menu-submenu .ant-menu-item {
    padding-left: 40px !important;
  }
`

export const NotiWrapper = styled.div`
  ::-webkit-scrollbar {
    width: 5px;
    border-radius: 5px;
  }

  width: 450px;
  background-color: #fff;
  border-radius: 20px;
  border-top-right-radius: 0;
  transition: 0.4s;
  overflow-y: auto;
  box-shadow: 0 4px 40px 0 #00000026;
  text-align: left;
  padding: 8px;
  padding-bottom: 20px;

  .close-notification {
    width: 24px;
    height: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    transition: 0.3s;

    &:hover {
      background-color: #f7f7f7;
      cursor: pointer;
    }
  }

  .ant-tabs-nav {
    margin: 0;
  }
  .ant-tabs-nav-wrap {
    justify-content: center;
  }
`
